<div class="wrapper">
  <app-nav></app-nav>
  <app-sidebar></app-sidebar>
  <div class="content-main">
    <router-outlet></router-outlet>
    <app-footer></app-footer>
  </div>
</div>
